import { makeStyles } from '@material-ui/core'

export const useCreateEditPageModalStyles = makeStyles(theme => ({
  dialogPaper: {
    margin: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      margin: 0,
      maxHeight: '100%',
      borderRadius: 0,
    },
  },
  dialogTitle: {
    paddingBottom: theme.spacing(0.5),
  },
  dialogHeading: {
    fontFamily: 'Graphik Medium, sans-serif',
    fontSize: '1.125rem',
    fontWeight: 500,
    lineHeight: 1.35,
    color: theme.palette.text.primary,
    marginBottom: 0,
    textTransform: 'lowercase',
  },
  dialogContent: {
    padding: theme.spacing(1, 3, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1, 2, 2.5),
    },
  },
  introText: {
    fontFamily: 'Graphik Light, sans-serif',
    fontSize: '0.875rem',
    lineHeight: 1.45,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  formStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  fieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  formField: {
    marginTop: 0,
    marginBottom: 0,
    '& .MuiInputLabel-root': {
      fontFamily: 'Graphik Medium, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.3,
      letterSpacing: '0.01em',
      color: theme.palette.text.primary,
      textTransform: 'none',
      position: 'relative',
      transform: 'none',
      marginBottom: theme.spacing(1),
    },
    '& .MuiInputLabel-shrink': {
      transform: 'none',
    },
    '& .MuiInputLabel-asterisk': {
      color: theme.palette.error.main,
    },
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
    '& .MuiInputBase-root': {
      marginTop: 0,
      alignItems: 'flex-start',
      fontFamily: 'Graphik Regular, sans-serif',
      fontSize: '1rem',
      lineHeight: 1.5,
      color: theme.palette.text.primary,
      '&:before': {
        borderBottomColor: 'rgba(0, 0, 0, 0.42)',
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottomColor: theme.palette.text.primary,
      },
      '&.Mui-focused:after': {
        borderBottomWidth: 2,
        borderBottomColor: theme.palette.primary.main,
      },
      '&.Mui-error:after': {
        borderBottomColor: theme.palette.error.main,
      },
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(0.75, 0, 1),
      fontFamily: 'Graphik Regular, sans-serif',
      fontSize: '1rem',
      lineHeight: 1.5,
      letterSpacing: 'normal',
      color: theme.palette.text.primary,
    },
    '& .MuiInputBase-inputMultiline': {
      padding: theme.spacing(0.75, 0, 1),
      margin: 0,
      boxSizing: 'border-box',
      minHeight: 72,
      lineHeight: 1.5,
      fontSize: '1rem',
      letterSpacing: 'normal',
      resize: 'vertical',
    },
    '& .MuiFormHelperText-root': {
      fontFamily: 'Graphik Light, sans-serif',
      fontSize: '0.75rem',
      lineHeight: 1.4,
      marginTop: theme.spacing(0.75),
      marginLeft: 0,
      color: theme.palette.text.secondary,
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    [theme.breakpoints.down('xs')]: {
      '& .MuiInputBase-inputMultiline': {
        minHeight: 64,
      },
    },
  },
  errorMessage: {
    fontFamily: 'Graphik Regular, sans-serif',
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
    marginBottom: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'stretch',
      '& > *': {
        width: '100% !important',
        maxWidth: '100% !important',
        minWidth: '0 !important',
      },
    },
  },
}))
